export default __webpack_public_path__ + "static/media/product-image-hover-23.684f91e7.jpg";